
import React from "react";

// reactstrap components
import { Container } from "reactstrap";

// core components

function SectionChronologyThanks() {
  return (
    <>
      <div className="section section-dark gradient-background-claro">

        <Container>
          <blockquote className="blockquote">
            <p className="mb-0">
              A special thanks to BobNostalgic for participating in this challenging <br />
              process to achieve a much more produced and elaborated end result. <br />
            </p>
            <br />
            <footer className="blockquote-footer">
              {"Daniloabella"}
            </footer>
          </blockquote>
        </Container>

      </div>
    </>
  );
}

export default SectionChronologyThanks;
